const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const lowercase = "abcdefghijklmnopqrstuvwxyz";
const numbers = "0123456789";
const all = uppercase + lowercase + numbers;

export function randomString(length = 6): string {
  let r = "";

  for (let i = 0; i < length; i++) {
    r += all[Math.round(Math.random() * all.length)];
  }

  return r;
}
